import type {
  ChatMessage,
  ChatParticipant,
  ChatRoom,
  ChatRoomSummary,
} from './types';

type RawChatRoom = {
  id?: string | number;
  participants?: Array<string | number>;
  createdAt?: string;
};

type RawParticipant = {
  id?: string | number;
  firstName?: string;
  lastName?: string;
  picture?: string | null;
};

type RawChatMessage = {
  id?: string | number;
  chatRoomID?: string | number;
  chatRoomId?: string | number;
  message?: string;
  body?: string;
  status?: string;
  ownerID?: string | number;
  ownerId?: string | number;
  toID?: string | number;
  toId?: string | number;
  createdAt?: string;
  updatedAt?: string;
};

function toId(value: string | number | undefined | null): string {
  return value == null ? '' : String(value);
}

export function mapChatRoom(raw: RawChatRoom): ChatRoom {
  return {
    id: toId(raw.id),
    participants: (raw.participants ?? []).map(toId),
    createdAt: raw.createdAt ?? '',
  };
}

export function mapChatParticipant(raw: RawParticipant): ChatParticipant {
  return {
    id: toId(raw.id),
    firstName: raw.firstName ?? '',
    lastName: raw.lastName ?? '',
    picture: raw.picture ?? null,
  };
}

export function mapChatMessage(raw: RawChatMessage): ChatMessage {
  return {
    id: toId(raw.id),
    chatRoomId: toId(raw.chatRoomId ?? raw.chatRoomID),
    body: raw.body ?? raw.message ?? '',
    status: raw.status ?? 'new',
    ownerId: toId(raw.ownerId ?? raw.ownerID),
    toId: toId(raw.toId ?? raw.toID),
    createdAt: raw.createdAt ?? '',
    updatedAt: raw.updatedAt ?? '',
  };
}

export function toChatRoomSummary(
  room: ChatRoom,
  peer: ChatParticipant,
): ChatRoomSummary {
  return { ...room, peer };
}

export function displayName(participant: ChatParticipant): string {
  return `${participant.firstName} ${participant.lastName}`.trim();
}
